import React, { Component } from 'react';

export class SelectableList extends Component {
  constructor(props) {
    super(props);
    this.selectedOption = this.selectedOption.bind(this);
  }

  selectedOption() {
    if (this.props.list.indexOf(this.props.selected) > -1) {
      return this.props.selected;
    } else {
      return '';
    }
  }

  render() {
    return (
      <div className="wrap">
        <div className="crop">
          <select className="listbox" value={this.selectedOption()} onChange={this.props.onClick} size="20" onDoubleClick={this.props.onDoubleClick}>
            <option disabled hidden value=''></option>
            {this.props.list.map((name) =>
              <option key={name} value={name}>{name}</option>
              )
            }
          </select>
        </div>
      </div>
    );
  }
}
